import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { S, SANS } from "../SoulumoLaunch/slUi";
import { HeroA, HeroB, HeroC } from "../SoulumoLaunch/slHeroes";

const API = process.env.REACT_APP_BACKEND_URL;
const OPTIONS = [
  ["A", "Adelaida in the light", "She is inside the photograph, welcoming you into a luminous morning room. Light cream page, navy ink.", HeroA],
  ["B", "Your guide, front and centre", "Soulumo navy on the left; Adelaida large, golden-lit and arched on the right, her words appearing as she speaks.", HeroB],
  ["C", "A new beginning", "A bright morning by the sea; Adelaida appears as a glass guide card with her portrait and live words.", HeroC],
];

// Review page: three hero directions to choose from before the launch page changes.
export default function SoulumoHeroOptions() {
  const [g, setG] = useState(null);
  useEffect(() => { axios.get(`${API}/api/soulumo-launch/content`).then((r) => setG(r.data.guide)).catch(() => setG(false)); }, []);
  if (!g) return <div className="min-h-screen flex items-center justify-center" style={{ background: S.night }}><Loader2 className="animate-spin" color={S.gold} /></div>;
  return (
    <main className="gp-root" style={{ background: S.night }} data-testid="hero-options-page">
      {OPTIONS.map(([k, title, note, Hero]) => (
        <div key={k}>
          <div className="sticky top-0 z-30 flex items-center gap-4 px-6 sm:px-10 py-3" style={{ background: "rgba(7,13,29,0.92)", backdropFilter: "blur(10px)", borderBottom: `1px solid ${S.goldSoft}` }} data-testid={`hero-option-label-${k.toLowerCase()}`}>
            <span className="w-8 h-8 rounded-full inline-flex items-center justify-center text-sm" style={{ background: S.gold, color: S.night, fontFamily: SANS, fontWeight: 700 }}>{k}</span>
            <span style={{ fontFamily: SANS, color: S.cream }} className="text-sm">{title}<span className="hidden sm:inline" style={{ color: S.dim }}> · {note}</span></span>
          </div>
          <Hero g={g} testId={`hero-${k.toLowerCase()}`} />
        </div>
      ))}
    </main>
  );
}
